import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useToast } from '../store/toast';

/** Global transient toast (e.g. "Copied"). Mounted once at the app root; driven
 *  by the toast store. Stays mounted and fades so the message doesn't blink out. */
export function Toast() {
  const message = useToast((s) => s.message);
  const [text, setText] = useState('');
  useEffect(() => {
    if (message) setText(message);
  }, [message]);

  return createPortal(
    <div className="pointer-events-none fixed inset-x-0 bottom-[calc(env(safe-area-inset-bottom,0px)+108px)] z-[90] flex justify-center px-8">
      <div
        className="rounded-full bg-black/80 px-4 py-[10px] text-[14px] font-medium text-white shadow-[0_8px_30px_rgba(0,0,0,0.24)] backdrop-blur-sm transition-all duration-200"
        style={{
          opacity: message ? 1 : 0,
          transform: message ? 'translateY(0)' : 'translateY(8px)',
        }}
      >
        {text}
      </div>
    </div>,
    document.body,
  );
}
